import React, { useMemo } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { Monitor, Smartphone, Tablet } from 'lucide-react';
import { TOOLTIP_STYLE, PANEL, colorAt } from './chartTheme';

const DEVICE_ICONS = { desktop: Monitor, mobile: Smartphone, tablet: Tablet };

function DeviceLegend({ devices, total }) {
  return (
    <div className="space-y-2 mt-2">
      {devices.map((d, i) => {
        const DeviceIcon = DEVICE_ICONS[d.device] || Monitor;
        return (
          <div key={d.device} className="flex items-center gap-2" data-testid={`device-row-${d.device}`}>
            <div className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: colorAt(i) }} />
            <DeviceIcon size={12} className="text-earth/40" />
            <span className="text-xs text-earth/60 font-sans capitalize flex-1">{d.device}</span>
            <span className="text-xs text-earth-dark font-sans font-semibold">{Math.round((d.count / total) * 100)}%</span>
            <span className="text-[10px] text-earth/30 font-sans">({d.count})</span>
          </div>
        );
      })}
    </div>
  );
}

export default function DeviceBreakdown({ devices }) {
  const total = useMemo(() => devices.reduce((acc, d) => acc + d.count, 0) || 1, [devices]);
  return (
    <div className={PANEL} data-testid="device-breakdown">
      <h3 className="font-display text-sm font-bold text-earth-dark mb-4">Device Breakdown</h3>
      {devices.length > 0 ? (
        <>
          <ResponsiveContainer width="100%" height={140}>
            <PieChart>
              <Pie data={devices} dataKey="count" nameKey="device" cx="50%" cy="50%" outerRadius={55} innerRadius={30} paddingAngle={2}>
                {devices.map((entry, i) => <Cell key={entry.device} fill={colorAt(i)} />)}
              </Pie>
              <Tooltip contentStyle={TOOLTIP_STYLE} />
            </PieChart>
          </ResponsiveContainer>
          <DeviceLegend devices={devices} total={total} />
        </>
      ) : (
        <div className="h-[200px] flex items-center justify-center text-earth/30 font-sans text-sm">No device data yet</div>
      )}
    </div>
  );
}
